var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Reproductor',{attrs:{"msg":"Los numeros","audio2":"../mp3/PrimariaA/04PA.mp3","cover":"../img/1.jpg","name":"Primaria A - Lección #4"}}),_c('Buttons')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }